import { VERSION } from 'src/version';

import { environment } from './../../../../environments/environment';
import { Constants } from './../../../core/config/constants';

export function openEmailForSupport(): void {
    const subject = `ForSiteApp ver ${getAppVersion()} - Support request`;
    window.location.href = `mailto:${Constants.IT_SUPPORT_EMAIL}?subject=${subject}`;
}

export function openEmail(emailTo: string, subject: string, body: string = null): void {
    window.location.href = `mailto:${emailTo}?subject=${subject}&body=${body}`;
}

export function getAppVersion(): string {
    return environment.env == Constants.PROD ? VERSION.version : `${VERSION.version}.${environment.env}`;
}

export function getApiVersion(): string {
    const api = environment.apiUrl;
    return api.includes('localhost') ? 'Dev' : api.includes('ForSiteArcPortalTest') ? 'Test' : '';
}
